module.exports = __webpack_public_path__ + "static/media/tess.5d7f27c7.png";